<div class="p-form-layout01 p-booking-info-mdl__row--mt16">
  <div class="p-form-layout01__item">
    <h3 class="p-form-layout01__item-title" [innerHTML]="this.departure + ' - ' + this.arrival"></h3>
    <div class="p-input-block01">
      <div *ngFor="let traveler of this.travelers; index as travelerIndex">
        <ng-container [formGroup]="this.formArray.controls[travelerIndex]">
          <div class="p-input-block01__item">
            <div class="p-input-block01__row-body">
              <div class="p-input-block01__row-body-item">
                <div
                  class="p-input-block01__row-title"
                  [innerHTML]="traveler.originTraveler.names?.[0]?.title + ' ' + traveler.originTraveler.names?.[0]?.firstName + ' ' + traveler.originTraveler.names?.[0]?.lastName"
                ></div>
                <div class="p-input-block01__row-body-item-column">
                  <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-column-responsive">
                    <asw-input
                      [id]="
                        'payment-input-shareholder-coupon-benefit-' +
                        boundIndex +
                        '-' +
                        flightIndex +
                        '-' +
                        travelerIndex
                      "
                      label="{{ 'label.shareholdersBenefitNumberInput' | staticMsg }}"
                      formControlName="shareholderBenefitNumber"
                      placeholder="{{ 'reader.shareholdersBenefitNumberInput' | staticMsg }}"
                      maxlength="8"
                      required
                      (change$)="update(travelerIndex)"
                      [displayType]="this.numberPrefix ? 'phone' : 'normal'"
                      [phoneCode]="this.numberPrefix"
                    ></asw-input>
                  </div>
                  <div
                    *ngIf="!isContainedShareholdersBenefitDiscountFareByPostCollection"
                    class="p-input-block01__row-body-item-box p-input-block01__row-body-item-column-responsive"
                  >
                    <asw-input
                      [id]="
                        'payment-input-shareholder-coupon-psw-' + boundIndex + '-' + flightIndex + '-' + travelerIndex
                      "
                      label="{{ 'label.shareholdersBenefit Password' | staticMsg }}"
                      formControlName="passwordForRegistration"
                      placeholder="{{ 'reader.shareholdersBenefitPassword' | staticMsg }}"
                      maxlength="16"
                      required
                      (change$)="update(travelerIndex)"
                      type="password"
                    ></asw-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
